<template>
    <div class="title1">
        <P>环境信息</P>
        <div class="title-info">Main equipment scale</div>
    </div>
    <div class="box">
        <div class="circle1"></div>
        <ul class="list">
            <li>
                <b></b>
                <p>磁感应强度.................</p>
                <span>100v/m</span>
            </li>
            <li>
                <b></b>
                <p>变电站噪声.................</p>
                <span>53dB</span>
            </li>
            <li>
                <b></b>
                <p>温度..........................</p>
                <span>18℃</span>
            </li>
            <li>
                <b></b>
                <p>湿度..........................</p>
                <span>51%RH</span>
            </li>
            <li>
                <b></b>
                <p>风速..........................</p>
                <span>7.23m/s</span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "environment"
    }
</script>

<style scoped lang="less">
    @import "./../../assets/canshu";
    .box{
        background: url("./../../assets/environment-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 363px;
        height: 193vh*@vh;
        margin-top: 26vh*@vh;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-family: cn;
        color: #fff;
        .circle1{
            background: url("./../../assets/environment-circle.png") no-repeat;
            background-size: 100% 100%;
            width: 134px;
            height: 134px;
        }
        .list{
            li{
                display: flex;
                align-items: center;
                margin-bottom: 16vh*@vh;
                b{
                    display: block;
                    background: url("./../../assets/list-ico.png") no-repeat;
                    background-size: 100% 100%;
                    width: 14px;/*no*/
                    height: 15px;/*no*/
                    margin-right: 5px;
                }
                p{
                    font-size: 10px;
                }
                span{
                    font-size: 14px;
                }
            }
        }
    }
</style>